import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=ed063292&scoped=true"
import script from "./studentDetail.vue?vue&type=script&lang=js"
export * from "./studentDetail.vue?vue&type=script&lang=js"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=ed063292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed063292",
  null
  
)

export default component.exports